import React from 'react'
import { string, bool, node } from 'prop-types'
import classNames from 'classnames'

import Icon from 'views/components/atoms/Icon'

import './TextWithIcon.scss'

const renderIcon = ({
  // eslint-disable-next-line react/prop-types
  icon,
  iconSize,
  iconSizeSmallTiny,
  iconClassName
}) => {
  if (icon) {
    return (
      <div className={iconClassName}>
        <Icon icon={icon} size={iconSize} sizeSmallTiny={iconSizeSmallTiny} />
      </div>
    )
  }

  return null
}

renderIcon.propTypes = {
  iconSize: string.isRequired,
  iconSizeSmallTiny: string.isRequired,
  iconClassName: string.isRequired
}

const TextWithIcon = ({
  centered,
  between,
  inline,
  alignToTop,
  icon,
  iconColor,
  iconBgColor,
  iconSize,
  iconSizeSmallTiny,
  iconRound,
  right,
  children,
  alignIconToTop
}) => {
  const className = classNames('l-flex', {
    'l-flex--center': centered,
    'l-flex--distribute-space': between,
    'l-flex--inline': inline,
    'l-flex--start': alignToTop || iconRound,
    'u-padding-large--top': iconRound
  })
  const iconClassName = classNames('m-TextWithIcon__icon', {
    [`u-color--${iconColor}`]: iconColor,
    [`u-background-color--${iconBgColor}`]: iconBgColor && iconRound,
    'u-margin-xx-small--right': iconSize !== 'large' && !right,
    'u-margin--right': iconSize === 'large' && !right,
    'u-margin-xx-small--left': iconSize !== 'large' && right,
    'u-margin--left': iconSize === 'large' && right,
    'm-TextWithIcon__icon--round u-margin-large--right': iconRound,
    'l-flex__start': alignIconToTop
  })

  return (
    <div className={className}>
      {!right &&
        renderIcon({
          icon,
          iconSize,
          iconSizeSmallTiny,
          iconClassName
        })}
      <div className="m-TextWithIcon__text">{children}</div>
      {right &&
        renderIcon({
          icon,
          iconSize,
          iconSizeSmallTiny,
          iconClassName
        })}
    </div>
  )
}

TextWithIcon.propTypes = {
  icon: string,
  iconSize: string,
  iconSizeSmallTiny: string,
  iconColor: string,
  iconBgColor: string,
  centered: bool,
  between: bool,
  inline: bool,
  right: bool,
  alignToTop: bool,
  iconRound: bool,
  children: node.isRequired,
  alignIconToTop: bool
}

TextWithIcon.defaultProps = {
  icon: '',
  iconSize: null,
  iconSizeSmallTiny: null,
  iconColor: '',
  iconBgColor: '',
  centered: false,
  between: false,
  inline: false,
  right: false,
  alignToTop: null,
  iconRound: null,
  alignIconToTop: false
}

export default TextWithIcon
